import React from 'react';

import { Box, Flex } from '@lightspeed/flame/Core';

import { AddModuleToAccountButton } from 'root/apps/ModuleCompareUI/components/AddModuleToAccountButton';
import { DeleteModuleButton } from 'root/apps/ModuleCompareUI/components/DeleteModuleButton';
import { StrikeThroughText, StyledFlex } from 'root/apps/ModuleCompareUI/ModuleCompare.style';
import { ModuleList } from 'root/apps/ModuleCompareUI/ModuleCompare.types';

type ModuleDifferenceRendererProps = {
  modules: ModuleList;
  accountId: string;
  secondAccountId: string;
  fromAccountEditable: boolean;
  toAccountEditable: boolean;
};

export const ModuleDifferenceRenderer: React.FC<ModuleDifferenceRendererProps> = ({
  modules,
  accountId,
  secondAccountId,
  fromAccountEditable,
  toAccountEditable,
}) => {
  return (
    <StyledFlex flexDirection="column" maxWidth="800px" mt={6}>
      <Flex className="header" flexDirection="row" justifyContent="space-between">
        <Box alignSelf="center" padding={1} width={300}>
          Account: {accountId}
        </Box>
        {/* <Flex alignItems="center"> */}
        {/*  {fromAccountEditable && ( */}
        {/*    <CopyAllModulesButton */}
        {/*      fromAccountId={secondAccountId} */}
        {/*      toAccountId={accountId} */}
        {/*      modules={modules} */}
        {/*    /> */}
        {/*  )} */}
        {/*  {toAccountEditable && ( */}
        {/*    <CopyAllModulesButton */}
        {/*      fromAccountId={accountId} */}
        {/*      toAccountId={secondAccountId} */}
        {/*      modules={modules} */}
        {/*      currentAcct={true} */}
        {/*    /> */}
        {/*  )} */}
        {/* </Flex> */}
        <Flex flexDirection="column" width={300} alignItems="end">
          <Box p={1}>Account: {secondAccountId}</Box>
        </Flex>
      </Flex>
      {Object.entries(modules).map(([moduleId, moduleData]) => {
        const firstAccountHasModule = moduleData[accountId];
        const secondAccountHasModule = moduleData[secondAccountId];
        const { name: moduleName, canEdit } = moduleData;

        if (!moduleName) return null;

        return (
          <Flex
            className="diff-row"
            flexDirection="row"
            justifyContent="space-between"
            key={moduleId}
          >
            <Flex
              padding={2}
              flexDirection="row"
              style={{ gap: '8px', wordBreak: 'break-word' }}
              maxWidth="46%"
              width="100%"
              alignItems="center"
              justifyContent="start"
            >
              {firstAccountHasModule ? (
                <>
                  {canEdit && fromAccountEditable && (
                    <DeleteModuleButton
                      moduleId={moduleId}
                      moduleName={moduleName}
                      deleteAcId={accountId}
                    />
                  )}
                  {moduleName}
                </>
              ) : (
                <StrikeThroughText size="small" color="gray-200">
                  NA
                </StrikeThroughText>
              )}
            </Flex>
            <Flex maxWidth="8%" width="100%" justifyContent="center" alignItems="center">
              {canEdit && (
                <AddModuleToAccountButton
                  accountId={accountId}
                  moduleData={moduleData}
                  moduleId={moduleId}
                  secondAccountId={secondAccountId}
                  fromAccountEditable={fromAccountEditable}
                  toAccountEditable={toAccountEditable}
                />
              )}
            </Flex>
            <Flex
              padding={2}
              flexDirection="row"
              style={{ gap: '8px', wordBreak: 'break-word' }}
              maxWidth="46%"
              width="100%"
              alignItems="center"
              justifyContent="end"
            >
              {secondAccountHasModule ? (
                <>
                  {moduleName}
                  {canEdit && toAccountEditable && (
                    <DeleteModuleButton
                      moduleId={moduleId}
                      moduleName={moduleName}
                      deleteAcId={secondAccountId}
                    />
                  )}
                </>
              ) : (
                <StrikeThroughText size="small" color="gray-200">
                  NA
                </StrikeThroughText>
              )}
            </Flex>
          </Flex>
        );
      })}
    </StyledFlex>
  );
};
